import {Modal, Text} from '@forecast-it/design-system';
import React from 'react';
import {useIntl} from 'react-intl';
import {MODAL_TYPE, showModal} from '../../modals/generic_modal_conductor';
import {ModalProps} from '../../modals/types';

export type DiscardConversationConfirmationModalPayload = {
	onConfirm: () => void;
};

export const showDiscardConversationConfirmationModal = (props: DiscardConversationConfirmationModalPayload): void => {
	showModal({
		type: MODAL_TYPE.DISCARD_NOVA_CONVERSATION_CONFIRMATION,
		...props,
	});
};

// Discard is asked about rather than done, for the same reason changing agent is: it takes away
// every reply the customer has sent, and nothing in the thread offers a way back. The copy says
// what is lost and where the task lands, so the confirmation is a real decision rather than a
// speed bump.
export const DiscardConversationConfirmationModal = ({
	closeModal,
	onConfirm,
}: ModalProps<DiscardConversationConfirmationModalPayload>): JSX.Element => {
	const {formatMessage} = useIntl();

	const handleConfirm = (): void => {
		onConfirm();
		closeModal();
	};

	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal} closeOnInteractOutside={false}>
			<Modal.Title>{formatMessage({id: 'nova_thread.discard.confirm_title'})}</Modal.Title>
			<Modal.Content>
				<Text>{formatMessage({id: 'nova_thread.discard.confirm_body'})}</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={handleConfirm} dataCy="nova-discard-confirm">
					{formatMessage({id: 'nova_thread.discard.confirm_cta'})}
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal} dataCy="nova-discard-cancel">
					{formatMessage({id: 'nova_thread.discard.keep_conversation'})}
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};
